import React from 'react'
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

import FormControl from '@mui/material/FormControl';
import SearchIcon from '@mui/icons-material/Search';
import InputAdornment from '@mui/material/InputAdornment';

import { Grid, InputLabel, MenuItem } from '@mui/material';
import { PrimaryOutlinedButton, PrimaryLightInput, PrimaryLightSelect } from '../theme/index';
import { useDispatch, useSelector } from 'react-redux';
import { saveReservationsAction, editFormActions, prevoiusFormAction, showMessageAction } from '../redux/reducers/MultiBooking';
import { useNavigate } from 'react-router-dom';

const steps = ['Reserva', 'Reserva', 'Reserva'];

const CreateMultiBooking = () => {

  const navigate = useNavigate();
  const [activeStep, setActiveStep] = React.useState(0);
  const [skipped, setSkipped] = React.useState(new Set());
  const dispatch = useDispatch();

  const [ documentType, setDocumentType ] = React.useState('');
  const [ documentNumber, setDocumentNumber ] = React.useState('');
  const [ name, setName ] = React.useState('');
  const [ lastName, setLastName ] = React.useState('');
  const [ email, setEmail ] = React.useState('');
  const [ room, setRoom ] = React.useState('');

  const reservationDate = useSelector( state => state.MultiBooking.reservations );
  const formData = useSelector( state => state.MultiBooking.forms );
  const formNumber = useSelector( state => state.MultiBooking.formNumber );

  React.useEffect( () => {
    if( reservationDate.length <= 0 ) navigate('/multibooking');
  },[] );

  React.useEffect( () => {
    const detectForm = () => {
        if( formData[formNumber] ){
            setDocumentType(formData[formNumber].doctype);
            setDocumentNumber(formData[formNumber].docnumber);
            setName(formData[formNumber].name);
            setLastName(formData[formNumber].lastName);
            setEmail(formData[formNumber].email);
            setRoom(formData[formNumber].room);
        }
    }

    detectForm();
  },[formNumber] );

  const saveForm = () => {
    const formObject = {
      docnumber: documentNumber,
      doctype: documentType,
      name: name,
      lastName: lastName,
      email: email,
      room: room
    }

    if(formData[activeStep]){
        if((activeStep+1) !== reservationDate.length) dispatch(prevoiusFormAction((activeStep+1)))
        if( formData[formNumber].docnumber !== documentNumber ||
            formData[formNumber].docnumber !== documentType || 
            formData[formNumber].name !== name || 
            formData[formNumber].lastName !== lastName || 
            formData[formNumber].email !== email || 
            formData[formNumber].room !== room ) dispatch(editFormActions((activeStep), formObject));
    }else{
        dispatch(saveReservationsAction((activeStep+1), formObject));
    }

    setDocumentNumber('');
    setDocumentType('');
    setName('');
    setLastName('');
    setEmail('');
    setRoom('');

    if((activeStep+1) === reservationDate.length){
        dispatch(prevoiusFormAction((activeStep)));
        dispatch(showMessageAction());
        navigate('/multibooking');
    }
       
    handleNext();
    
  }

  const isStepSkipped = (step) => {
    return skipped.has(step);
  };

  const handleNext = () => {
    let newSkipped = skipped;
    if (isStepSkipped(activeStep)) {
      newSkipped = new Set(newSkipped.values());
      newSkipped.delete(activeStep);
    }

    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    setSkipped(newSkipped);
  };

  const handleBack = () => {
    dispatch(prevoiusFormAction((activeStep-1)));
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleSkip = () => {

    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    setSkipped((prevSkipped) => {
      const newSkipped = new Set(prevSkipped.values());
      newSkipped.add(activeStep);
      return newSkipped;
    });
  };

  const handleReset = () => {
    setActiveStep(0);
  };

  return (
    <Grid container sx={{ justifyContent: 'center', mt: 4 }}>
        <Grid item xs={10}>
            <Box sx={{ width: '100%' }}>
            <Stepper activeStep={activeStep}>
                {reservationDate.map((label, index) => {
                const stepProps = {};
                const labelProps = {};
                if (isStepSkipped(index)) {
                    stepProps.completed = false;
                }
                return (
                    <Step key={index} {...stepProps} sx={{ py: 5 }}>
                        <StepLabel {...labelProps}></StepLabel>
                    </Step>
                );
                })}
            </Stepper>
            {activeStep === reservationDate.length ? (
                <React.Fragment>
                <Typography sx={{ mt: 2, mb: 1 }}>
                    Todas las reservas han sido creadas exitosamente!
                </Typography>
                <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
                    <Box sx={{ flex: '1 1 auto' }} />
                    <Button onClick={handleReset}>Reset</Button>
                </Box>
                </React.Fragment>
            ) : (
                <React.Fragment>
                
                <Grid container sx={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Grid item xs={ 6 } sx={{ mt: 4 }}>
                        <h5 style={{ margin: '0' }}>Crear reserva</h5>
                        <p style={{ margin: '0' }}>{ reservationDate[activeStep].start } - { reservationDate[activeStep].end }</p>
                    </Grid>
                    <Grid item xs={ 4 } sx={{ mt: 4 }}>
                        <PrimaryLightInput
                            placeholder="Buscar cliente"
                            fullWidth
                            InputProps={{
                                startAdornment: (
                                <InputAdornment position="start">
                                    <SearchIcon />
                                </InputAdornment>
                                ),
                            }}
                        />
                    </Grid>
                </Grid>
                <Grid item xs={ 12 } sx={{ mt: 6 }}>
                    <p>Huésped</p>
                </Grid>
                <Grid item xs={ 12 }>
                    <Grid container>
                    <Grid item xs={ 6 } sx={{ mb: 2}} className='pr-2'>
                        <FormControl fullWidth>
                            <InputLabel id="demo-simple-select-label">Tipo de documento</InputLabel>
                            <PrimaryLightSelect 
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            label="Tipo de documento"
                            value={ documentType }
                            onChange={ e => setDocumentType(e.target.value) }
                            >
                                <MenuItem value='passport'>Pasaporte</MenuItem>
                                <MenuItem value="v">V-</MenuItem>
                                <MenuItem value="e">E-</MenuItem>
                                {/* <MenuItem value='identification'>Nº de identificación</MenuItem> */}
                            </PrimaryLightSelect>
                        </FormControl>
                    </Grid>
                    <Grid item xs={ 6 } sx={{ mb: 2}} className='pr-2'>
                        <PrimaryLightInput
                            label="Nº de documento"
                            value={ documentNumber }
                            onChange={ e => setDocumentNumber(e.target.value) }
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={ 6 } sx={{ mb: 2}} className='pr-2'>
                        <PrimaryLightInput
                            label="Nombre"
                            value={ name }
                            onChange={ e => setName(e.target.value) }
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={ 6 } sx={{ mb: 2}} className='pr-2'>
                        <PrimaryLightInput
                            label="Apellido"
                            value={ lastName }
                            onChange={ e => setLastName(e.target.value) }
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={ 6 } className='pr-2'>
                        <PrimaryLightInput
                            label="E-mail"
                            value={ email }
                            onChange={ e => setEmail(e.target.value) }
                            fullWidth
                        />
                    </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={ 12 } sx={{ mt: 2 }}>
                    <p>Habitación</p>
                </Grid>
                <Grid item xs={ 6 } sx={{ mb: 2}} className='pr-2'>
                        <FormControl fullWidth>
                            <InputLabel id="demo-simple-select-label">Tipo de Habitación</InputLabel>
                            <PrimaryLightSelect 
                            value={ room }
                            onChange={ e => setRoom(e.target.value) }
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            >
                                <MenuItem value='double-bed'>Matrimonial</MenuItem>
                                <MenuItem value='personal'>Personal</MenuItem>
                                <MenuItem value='double'>Doble</MenuItem>
                                <MenuItem value='junior-suite'>Junior Suite</MenuItem>
                                <MenuItem value='suite'>Suite</MenuItem>
                            </PrimaryLightSelect>
                        </FormControl>
                </Grid>

                <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
                    <Button
                    color="inherit"
                    disabled={activeStep === 0}
                    onClick={handleBack}
                    sx={{ mr: 1 }}
                    >
                    Back
                    </Button>
                    <Box sx={{ flex: '1 1 auto' }} />

                    {
                        (activeStep === reservationDate.length - 1) ?
                            <Button onClick={ () => saveForm() }>Crear Reservas</Button>
                        :
                            <Button onClick={ () => saveForm() }>Siguiente</Button>

                    }
                </Box>
                </React.Fragment>
            )}
            </Box>
        </Grid>
    </Grid>
  )
}

export default CreateMultiBooking